export interface ICustomService {
    catalogOfferCode: string;
    id: number;
    name: string;
    status: ESubscriptionStatus;
    subscriptionId: number;
}

export interface ISubscriptionPage {
    content: ISubscriptionResponse[];
}

export interface ISubscriptionResponse {
    catalogOfferCode: string;
    id: number;
    status: ESubscriptionStatus;
}

export interface IServicePage {
    content: IServiceResponse[];
}

interface IServiceResponse {
    domain: string;
    id: number;
    name: string;
    subscriptionId: number;
}

export enum ESubscriptionStatus {
    INITIAL = "INITIAL",
    ACTIVE = "ACTIVE",
    TERMINATED = "TERMINATED",
    CLOSED = "CLOSED",
}
